import PropTypes from 'prop-types';
import React from 'react';

const ActionTooltip = ({ tooltip, showTooltip, placement }) => {
  const visibilityClass = showTooltip ? 'show' : 'hide';
  const customClass = `popuptext ${visibilityClass} ${placement}`;

  return (
    <span className={customClass} dangerouslySetInnerHTML={{ __html: tooltip }}></span>
  );
};

ActionTooltip.propTypes = {
  tooltip: PropTypes.string,
  showTooltip: PropTypes.bool,
  placement: PropTypes.string
};

ActionTooltip.defaultProps = {
  placement: ''
};

export default ActionTooltip;
